/**
 * U SSO
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface InfoResult { 
    /**
     * Product name
     */
    name?: string;
    /**
     * Specification Title
     */
    specificationTitle?: string;
    /**
     * Specification Version
     */
    specificationVersion?: string;
    /**
     * Specification Vendor
     */
    specificationVendor?: string;
    /**
     * Implementation Title
     */
    implementationTitle?: string;
    /**
     * Implementation Version
     */
    implementationVersion?: string;
    /**
     * Implementation Vendor
     */
    implementationVendor?: string;
    /**
     * Application Authenticated IdLogin
     */
    applicationAuthenticatedIdLogin?: string;
    /**
     * Application Authenticated NIF
     */
    applicationAuthenticatedNif?: string;
    /**
     * Application Authenticated Name
     */
    applicationAuthenticatedName?: string;
    /**
     * Application Authenticated Commercial Name
     */
    applicationAuthenticatedCommercialName?: string;
    /**
     * User Authenticated IdLogin
     */
    userAuthenticatedIdLogin?: string;
    /**
     * User Authenticated NIF
     */
    userAuthenticatedNif?: string;
    /**
     * User Authenticated Email
     */
    userAuthenticatedEmail?: string;
    /**
     * Birth Date. Format yyyy-MM-dd HH:mm:ss
     */
    userAuthenticatedBirthDate?: string;
    /**
     * User Authenticated Full Name
     */
    userAuthenticatedFullName?: string;
    /**
     * User Authenticated Postal Info
     */
    userAuthenticatedPostalInfo?: string;
    /**
     * User Authenticated Phone Info
     */
    userAuthenticatedPhoneInfo?: string;
    /**
     * System configurations
     */
    systemConfigurations?: { [key: string]: string; };
}

